"use client";
import { useEffect, useState } from "react";

const checkIsPC = () => {
  return window.innerWidth > 520;
};

export function useIsPc() {
  const [isPC, setIsPc] = useState(false);

  useEffect(() => {
    window.addEventListener("resize", () => {
      setIsPc(checkIsPC());
    });
    setIsPc(checkIsPC());
  }, []);

  return [isPC];
}
